
// const baseUrl = 'http://127.0.0.1:8079';
const baseUrl = 'https://zhjs.article.life-oasis.com/article';
export default baseUrl;
